import React, { useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Row,
  Container,
  Input,
  CardHeader,
  Label,
} from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import Dropzone from "react-dropzone";
import { Link } from "react-router-dom";
import img1 from "../../assets/images/new-document.png";
import CheckboxTree from "react-checkbox-tree";
// import "react-checkbox-tree/lib/react-checkbox-tree.css";
// import "../../../node_modules/react-checkbox-tree/lib/react-checkbox-tree.css";

const CasedataUpload = () => {
  document.title = "Data and Stamp Uploading | ApprentAI";
  const [selectedFiles, setselectedFiles] = useState([]);
  const [files, setFiles] = useState([]);

  const [checkBoxState, setCheckboxState] = useState({
    checked: [],
    expanded: [],
  });

  const nodes = [
    {
      value: "Folder 1",
      label: "Folder 1",
      checkModel: "all",
      disabled: false,
      children: [
        { value: "file 1.1", label: "file 1.1" },
        { value: "file 1.2", label: "file 1.2" },
      ],
    },
    {
      value: "Folder 2",
      label: "Folder 2",
      children: [
        {
          value: "file 2.1",
          label: "file 2.1",
          children: [
            { value: "file 2.1.1", label: "file 2.1.1" },
            { value: "file 2.1.2", label: "file 2.1.2" },
          ],
        },
        { value: "file 2.2", label: "file 2.2" },
      ],
    },
  ];
  //   EFF2F7
  function handleAcceptedFiles(files) {
    files.map((file) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      })
    );
    setselectedFiles(files);
  }

  /**
   * Formats the size
   */
  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }

  const handleSubmt = (e) => {
    e.preventDefault();
  };

  const deleteSelFile = (name) => {
    console.log(name);
    setselectedFiles(selectedFiles.filter((cval) => cval.name !== name));
  };

  return (
    <>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="CASE FILE UPLOAD" pageTitle="Dashboards" />
          <Row>
            <Col className="text-end my-3">
              <button className="btn btn-success me-2">
                Case Id : #######
              </button>
              <button className="btn btn-success">Parties : Dan v. Yuri</button>
            </Col>
          </Row>
          <Row>
            <Card>
              <CardBody>
                <Row>
                  <form onSubmit={handleSubmt}>
                    <Row>
                      <Col lg={3}>
                        <Card
                          style={{
                            boxShadow: "0 0 8px rgba(0,0,0,.15)",
                            background: "#EFF2F7",
                          }}
                        >
                          <CardBody>
                            <Dropzone
                              className="caseUpload-drpzone"
                              onDrop={(acceptedFiles) => {
                                handleAcceptedFiles(acceptedFiles);
                              }}
                            >
                              {({ getRootProps, getInputProps }) => (
                                <div className="dropzone dz-clickable">
                                  <div
                                    className="dz-message needsclick"
                                    {...getRootProps()}
                                  >
                                    <h6>Drop files here or click to upload.</h6>
                                  </div>
                                </div>
                              )}
                            </Dropzone>

                            <div className="mt-3">
                              <button className="btn btn-primary w-100">
                                Add Files
                              </button>
                            </div>
                            <div className="mt-3">
                              <button className="btn btn-primary w-100">
                                Connect Google Drive
                              </button>
                            </div>
                            <div className="mt-3">
                              <button className="btn btn-primary w-100">
                                Upload From Dropbox
                              </button>
                            </div>
                          </CardBody>
                        </Card>
                      </Col>
                      <Col lg={5}>
                        <Card
                          style={{
                            boxShadow: "0 0 8px rgba(0,0,0,.15)",
                            background: "#EFF2F7",
                          }}
                        >
                          <CardBody>
                            <div
                              className="list-unstyled mb-0"
                              id="file-previews"
                            >
                              {selectedFiles.map((f, i) => {
                                return (
                                  <Card
                                    className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                    key={i + "-file"}
                                  >
                                    <div className="p-2">
                                      <Row className="align-items-center">
                                        <Col className="col-auto">
                                          <img
                                            data-dz-thumbnail={img1}
                                            height="80"
                                            className="avatar-sm rounded bg-light"
                                            alt={f.name}
                                            src={f.preview}
                                          />
                                        </Col>
                                        <Col>
                                          <Link
                                            to="#"
                                            className="text-muted font-weight-bold"
                                          >
                                            {f.name}
                                          </Link>
                                          <p className="mb-0">
                                            <strong>{f.formattedSize}</strong>
                                          </p>
                                        </Col>
                                        <Col>
                                          <button
                                            onClick={() =>
                                              deleteSelFile(f.name)
                                            }
                                            className="btn btn-danger"
                                          >
                                            delete
                                          </button>
                                        </Col>
                                      </Row>
                                    </div>
                                  </Card>
                                );
                              })}
                            </div>

                            {/* <CheckboxTree
                              nodes={nodes}
                              checked={checkBoxState.checked}
                              expanded={checkBoxState.expanded}
                              onCheck={(checked) =>
                                setCheckboxState({ checked })
                              }
                              onExpand={(expanded) =>
                                setCheckboxState({ expanded })
                              }
                            /> */}

                            {selectedFiles.length > 0 ? (
                              <>
                                <button
                                  onClick={() => setselectedFiles([])}
                                  className="btn btn-secondary mt-2"
                                >
                                  Delete File
                                </button>
                              </>
                            ) : (
                              <></>
                            )}
                          </CardBody>
                        </Card>
                      </Col>
                      <Col lg={4}>
                        <Card
                          style={{
                            boxShadow: "0 0 8px rgba(0,0,0,.15)",
                            background: "#EFF2F7",
                          }}
                        >
                          <CardBody>
                            <Col lg={12}>
                              <div>
                                <Input
                                  type="text"
                                  placeholder=" Insert Stamp Name"
                                  className="form-control"
                                  id="stampname"
                                />
                              </div>
                            </Col>
                            <Col lg={12} className="my-3">
                              <div>
                                <Input
                                  type="text"
                                  placeholder=" Insert File Source"
                                  className="form-control"
                                  id="filesource"
                                />
                              </div>
                            </Col>
                            <Col lg={12}>
                              <div>
                                <Input
                                  type="text"
                                  placeholder=" Insert Files Data Recieved"
                                  className="form-control"
                                  id="filedatarecieved"
                                />
                              </div>
                            </Col>
                            <Col className="text-end">
                              <div>
                                <button className="btn btn-secondary mt-3">
                                  Stamp File
                                </button>
                              </div>
                            </Col>
                          </CardBody>
                        </Card>
                      </Col>
                      <Col lg={12} className="text-end">
                        <button type="submit" className="btn btn-primary">
                          Start Case
                        </button>
                      </Col>
                    </Row>
                  </form>
                </Row>
              </CardBody>
            </Card>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default CasedataUpload;
